import React from "react";
import ForgotPasswordBox from "../components/ForgotPassword/ForgotPassword"

function ForgotPassword() {
  return (
    <section>
      <ForgotPasswordBox />
    </section>
  );
}

export default ForgotPassword;
